module.exports = __webpack_public_path__ + "img/slide6_img3.6a0c7f49.png";